import styled from 'styled-components'

export const Header = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1;
    font-family: "Bebas Neue";
    letter-spacing: 2px;
    padding: 0.6rem 5%;
    overflow: hidden;
    background: #0791bb;
    box-shadow: 2px 2px 8px rgb(0,0,0,.2);

    h2 {
        display: inline-block;
        margin: 0;
        margin-right: 5rem;
        font-size: 1.rem;
        font-weight: 500;
    }

    h1 {
        font-size: 1.5rem;
        margin-top: .3rem;
        display: inline-block;
        color: #fff;
    }

    @media (max-width: 600px) {
        h2 {
            font-size: 1.5rem;
        }
    }
`

export const GoBackButton = styled.h3`
    margin: 0;
    margin-top: .3rem;
    float: right;
    display: inline-block;
    color: #ddd;
    cursor: pointer;

    &:hover {
        color: rgb(179, 221, 28); 
    }

    span {
        font-weight: 500;
        margin-left: 0.5rem;
        font-size: 1.2rem;
    }

`
export const TopLine = styled.div`
    top: 0;
    left: 0;
    position: absolute;
    width: 100%;
    height: 3px;
    background: linear-gradient(to right, #2acdff, rgb(179, 221, 28), rgb(28, 221, 125));
`
